/**
 * UUIDv7 gerado no dispositivo.
 *
 * Por que v7 e nao v4: os 48 bits iniciais sao o timestamp em milissegundos, o
 * que da ordenacao temporal de graca e boa localidade de indice no Postgres.
 * E por que gerado no dispositivo: o tablet passa quatro dias sem rede. Se o id
 * dependesse do servidor, nao haveria coleta offline.
 */
export function uuidv7(now: number = Date.now()): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // 48 bits de timestamp, big-endian.
  const ts = BigInt(now);
  bytes[0] = Number((ts >> 40n) & 0xffn);
  bytes[1] = Number((ts >> 32n) & 0xffn);
  bytes[2] = Number((ts >> 24n) & 0xffn);
  bytes[3] = Number((ts >> 16n) & 0xffn);
  bytes[4] = Number((ts >> 8n) & 0xffn);
  bytes[5] = Number(ts & 0xffn);

  // Versao 7 e variante RFC 4122.
  bytes[6] = (bytes[6]! & 0x0f) | 0x70;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Identidade do dispositivo. Entra em todo change_log: quando uma medida sair
 * estranha, da para saber de qual tablet ela veio.
 */
export function deviceId(storage: Pick<Storage, 'getItem' | 'setItem'>): string {
  const KEY = 'equiview.deviceId';
  let id: string | null = null;
  try {
    id = storage.getItem(KEY);
  } catch {
    // Storage bloqueado (janela anonima, cookies desligados). Segue sem persistir.
  }
  if (!id) {
    id = uuidv7();
    try {
      storage.setItem(KEY, id);
    } catch {
      /* idem */
    }
  }
  return id;
}

/**
 * Coluna de chave primaria de cada entidade. animal_management e
 * gait_subjective sao 1-para-1 com a ficha: a chave e assessment_id, como no
 * Postgres.
 */
export const chavePrimaria = (entity: string): string =>
  entity === 'animal_management' || entity === 'gait_subjective' ? 'assessment_id' : 'id';
